export const formStyles = {
  form: {
    width: '600px',
    backgroundColor: '#fff'
  },
  field: {
    marginBottom: '24px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      '& fieldset': {
        borderColor: '#E0E0E0'
      },
      '&:hover fieldset': {
        borderColor: '#6123FF'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#6123FF'
      }
    },
    '& .MuiInputLabel-root': {
      color: '#666',
      '&.Mui-focused': {
        color: '#6123FF'
      }
    }
  },
  readOnlyField: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#F5F5F5',
      '& fieldset': {
        borderColor: '#E0E0E0'
      }
    }
  },
  actions: {
    display: 'flex',
    gap: '16px',
    justifyContent: 'flex-end',
    marginTop: '32px'
  },
  cancelButton: {
    width: '120px',
    height: '40px',
    fontSize: '16px',
    fontWeight: 400,
    color: '#6123FF',
    boxShadow: 'none',
    padding: '10px 0px',
    fontFamily: 'Plus Jakarta Sans',
    textTransform: 'none',
    borderRadius: '8px',
    borderColor: '#6123FF'
  },
  submitButton: {
    width: '120px',
    height: '40px',
    borderRadius: '12px',
    textTransform: 'none',
    fontSize: '16px',
    fontWeight: 400,
    fontFamily: 'Plus Jakarta Sans',
    color: '#fff',
    backgroundColor: '#6123FF',
    boxShadow: 'none',
    '&:hover': {
      border: 'none',
      color: '#6123FF',
      backgroundColor: '#F0E7F9'
    }
  }
}
